import { bindCardSwipeButton, unbindCardSwipeButton } from '../../shared/card-swipe-button.js';
import { opCfg, opGatewayApiForId } from './config.js';
import { opModal, openPaymentIsOnline } from './dom.js';
import { parseAmount, submitOpenPaymentSwipe } from './submit.js';
import { showOpenPaymentAjaxMsg } from './ui-state.js';

function swipeGatewayId() {
    if (!openPaymentIsOnline()) {
        return null;
    }
    const $inputs = opModal().find('.open-payment-amount-input');
    const $targets = $inputs.length === 1
        ? $inputs
        : $inputs.filter(function () {
            return parseAmount($(this).val()) > 0;
        });
    if ($targets.length !== 1) {
        return null;
    }
    const gatewayId = parseInt(String($targets.data('gateway-id') || '0'), 10);
    return gatewayId > 0 ? gatewayId : null;
}

export function syncOpenPaymentSwipe() {
    const wrap = opModal().find('[data-card-swipe]').get(0);
    const button = opModal().find('[data-card-swipe-button]').get(0);
    if (!wrap || !button) {
        return;
    }

    const gatewayId = swipeGatewayId();
    if (!gatewayId) {
        delete wrap.dataset.gatewayId;
        unbindCardSwipeButton(button, wrap);
        return;
    }
    if (wrap.dataset.gatewayId === String(gatewayId)) {
        return;
    }

    wrap.dataset.gatewayId = String(gatewayId);
    bindCardSwipeButton({
        wrap,
        button,
        gatewayJavascriptUrl: (opCfg().gatewayJavascriptUrlsById || {})[String(gatewayId)],
        gatewayApi: opGatewayApiForId(gatewayId),
        onSwipe: (result) => submitOpenPaymentSwipe(result, gatewayId),
        onError: (message) => showOpenPaymentAjaxMsg('alert-danger', $('<li>').text(message).prop('outerHTML')),
    });
}
